module.exports = __webpack_public_path__ + "img/nexus.d9be24d7.png";